
new Swiper('.buly-article-carousel', {
    slidesPerView: 2.25,
    spaceBetween: 15,
    watchSlidesProgress: true,
    breakpoints: {
      750: {
        slidesPerView: 2.75,
        spaceBetween: 20
      },
      950: {
        slidesPerView: 3.5,
        spaceBetween: 20
      }
    },
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  })